import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_HOW_TO_APPLY_START, PUT_HOW_TO_APPLY_ERROR, PUT_HOW_TO_APPLY_START, PUT_HOW_TO_APPLY_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/how-to-apply/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_HOW_TO_APPLY_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_HOW_TO_APPLY_ERROR, error });
  } finally {
    yield put({ type: GET_HOW_TO_APPLY_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_how_to_apply() {
  yield takeLatest(PUT_HOW_TO_APPLY_START, edit);
}
